<template>
  <div class="sgCard" @click="toSHHDetail">
    <div class="sgCard_thumb" style="position:relative;"  v-if="cardType=='fy'">
      <slot name="thumb">
        <img v-lazy="{src:thumb,error: './static/images/empty/pg_shouyekong.png',loading: './static/images/empty/preload.gif'}">
        <div class='isNetWorkSign netWorkType1' v-if="ISNETWORKSIGN == 1&&!state"></div>
        <div class='isNetWorkSign netWorkType2' v-if='ISNETWORKSIGN == 2&&!state'></div>
        <div class='isNetWorkSign netWorkType3' v-if='state == 3'></div>
        <div class="sgCard_type" v-if="type">{{type}}</div>
        <!-- <div v-if="CLICKCOUNT!='undefined'" class="clickTime">{{CLICKCOUNT}} 浏览</div> -->
      </slot>
    </div>
    <div class="sgCard_intro"  v-if="cardType=='fy'">
      <slot name="intro">
        <h2 class="sgCard_title">{{title}}</h2>
        <p class="sgCard_message">{{message}}</p>
        <p class="sgCard_label"><span v-for="(i,index) in label" :key="index">{{i}}</span></p>
        <p class="sgCard_price"><span>{{total}}万元</span><span>{{price}}元/㎡</span></p>
      </slot>
    </div>
    
    <div class="wangqian" v-if="cardType=='wq'">
      <!-- <p class="qyType">
        <span>签约类型:一般产权网签</span>
      </p> -->
      <p :class="{qyHouseAdress:true,yiban:false,taofang:true}">
        <span>{{wqList.FWZL}}</span>
      </p>
      <p class="qyWay">
        <span class="payType">付款方式：{{wqList.PayWay}}</span>
        <span class="payWay">结算方式：{{wqList.AccountsWay}}</span>
      </p>
      <p class="qyHouseDetail">
        <span class="cqArea">产权面积：{{wqList.CQMJ}}㎡</span>
        <span class="houseUseful">规划用途：{{wqList.GHYT}}</span>
      </p>
      <p class="qyDJBH">
        <span class="cqDJBH">登记编号：{{wqList.DJBH}}</span>
      </p>
      
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Lazyload} from 'vant'
  Vue.use(Lazyload);

  export default {
    props: {
      thumb: String,
      title: String,
      message: String,
      label: Array,
      total: [String, Number],
      price: [String, Number],
      type: String,
      isSkip: Boolean,
      houseId: [String, Number],
      skipUrl: String,
      ISNETWORKSIGN: [String, Number],
      state: [String, Number],
      cardType:{
        type: String,
        default: 'fy',
      },
      wqList:{
        type:Object,
      },
      CLICKCOUNT: [String, Number]
      // cardclick:{
      //     type:Function,
      //     default:function(){
      //         this.$router.push({path:'/secondHandHouseDetail'});
      //     }
      // }
    },
    mounted() {
    },
    methods: {
      toSHHDetail() {
        if (this.isSkip) {
          if (this.skipUrl) {
            if (this.houseId) {
              this.$router.push({path: this.skipUrl, query: {id: this.houseId}});
            } else {

            }
          } else {

          }
        } else {
          
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .sgCard {
    // height:180px;
    overflow: hidden;
    padding: 19px 0 30px 0;
    margin-left: 30px;
    border-bottom: 1px solid #e4e4e4;
  }

  .sgCard:last-child {
    border: none;
  }
  .wangqian {
    height: 240px;
    margin-top: 11px;
    p {
      height:60px;
      font-size: 24px;
      line-height: 60px;
      color: #333333;
      padding-right: 30px;
    }
    .qyHouseAdress {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      line-height: 65px;
      height: 65px;
      span {
        margin: 0 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        display:-webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient:vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp:1; //显示的行
      }
    }
    .yiban {
      background-image: url(../assets/ybqy.png);
      background-position: 10px center;
      background-size: 60px 60px;
      background-repeat: no-repeat;
    }
    .taofang {
      background-image: url(../assets/tfwqy.png);
      background-position: 10px center;
      background-size: 50px 50px;
      background-repeat: no-repeat;
    }
    .qyWay {
      .payType {
        float: left;
        width: 50%;
      }
      .payWay {
        float: left;
        width: 50%;
      }
    }
    .qyHouseDetail {
      .cqArea {
        float: left;
        width: 50%;
      }
      .houseUseful {
        float: left;
        width: 50%;
      }
    }
  }
  .sgCard_thumb {
    width: 236px;
    height: 180px;
    float: left;
    position: relative;
    .sgCard_type {
      position: absolute;
      bottom: 8px;
      right: 12px;
      border-radius: 15px;
      background: rgba(51, 140, 253, 0.8);
      color: #fff;
      width: 60px;
      text-align: center;
      font-size: 20px;
      line-height: 30px;
      height: 30px;
    }
    .isNetWorkSign {
      width: 80px;
      height: 80px;
      background-size: 100% 100%;
      background-repeat:no-repeat;
      background-position:center;
      position:absolute;
      left:40px;
      top:65px;
    }
    .netWorkType1 {
      background-image: url('../assets/signed_icon.png');
    }
    .netWorkType2 {
      background-image: url('../assets/deal_icon.png');
    }
    .netWorkType3 {
      background-image: url('../assets/taked_icon.png');
    }
  }

  .sgCard_thumb img {
    width: 236px;
    height: 180px;
    margin-top: 11px;
  }

  .sgCard_intro {
    width: 415px;
    // padding-right: 30px;
    float: left;
    // height:180px;
    margin-left: 40px;
    overflow: hidden;

  }

  .sgCard_title {
    margin: 0;
    padding: 0;
    height:52px;
    font-size: 30px;
    line-height: 52px;
    color: #333333;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;
  }

  .sgCard_message {
    margin: 0;
    padding: 0;
    margin-top: 14px;
    height: 24px;
    font-size: 24px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sgCard_label {
    margin: 0;
    padding: 0;
    margin-top: 24px;
    height: 30px;
    font-size: 20px;
  }

  .sgCard_label span {
    color: #9a9a9a;
    background: #f3f3f3;
    padding: 0 12px;
    margin-right: 14px;
  }

  .sgCard_price {
    margin: 0;
    padding: 0;
    margin-top: 22px;
    height: 26px;
    font-size: 20px;
    line-height: 26px;
  }

  .clickTime {
    position: absolute;
    font-size: 24px;
    color: #9a9a9a;
    left: 150px;
    top: 150px;
  }

  .sgCard_price span:nth-child(1) {
    color: #ff474f;
    font-weight: 550;
    font-size: 26px;
  }

  .sgCard_price span:nth-child(2) {
    color: #9a9a9a;
    font-size: 24px;
    margin-left: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/sgCard.vue